import React from "react";
import MyNavbar from "../../../components/user/general/mynavbar/MyNavbar.js";
import Footer from "../../../components/user/general/footer/Footer.js";
import AboutUsBanner from "../../../subscreens/users/About/aboutbanner/AboutUsBanner.js";
import CompanyIntro from "../../../subscreens/users/About/companyintro/CompanyIntro.js";
import Split from "../../../subscreens/users/About/Split/Split.js";
import Industries from "../../../subscreens/users/About/industries/Industries.js";
import Team from "../../../subscreens/users/About/team/Team.js";
import QualityStandard from "../../../subscreens/users/Maintain/qualitystandard/QualityStandard.js";
import Counter from "../../../components/user/general/counter/Counter.js";
import Banner from "../../../subscreens/users/Home/banner/Banner.js";

const EquipmentCategory = () => {
  return (
    <>
      <MyNavbar />
      <AboutUsBanner />
      <CompanyIntro />
      <QualityStandard />
      <Split />
      {/* <Counter /> */}
      <br/><br/>
      <Banner />
      <Industries />

      {/* <Team /> */}
      <Footer />
    </>
  );
};

export default EquipmentCategory;
